import type { EShutterMaterial, EShutterType } from '../../../core/EShutterMaterial';
import { Length } from '../../../core/Length/Length';
import { DrawCabinetFrontElement } from './DrawCabinetFrontElement';

export class DrawFrontShutter extends DrawCabinetFrontElement {
    shutterLamellaHeight!: Length;

    material?: EShutterMaterial;
    type?: EShutterType;
}
